import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgOrientationPortrait = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.77411 3.01485C7.62666 3.20635 7.50996 3.50923 7.50996 3.87998L7.50996 19.88C7.50996 20.2507 7.62666 20.5536 7.77411 20.7451C7.9208 20.9356 8.06138 20.98 8.14996 20.98H15.85C15.9385 20.98 16.0791 20.9356 16.2258 20.7451C16.3733 20.5536 16.49 20.2507 16.49 19.88L16.49 3.87998C16.49 3.50923 16.3733 3.20635 16.2258 3.01485C16.0791 2.82435 15.9385 2.77998 15.85 2.77998L8.14996 2.77998C8.06138 2.77998 7.9208 2.82435 7.77411 3.01485ZM5.70996 3.87998C5.70996 2.51119 6.59785 0.97998 8.14996 0.97998L15.85 0.97998C17.4021 0.97998 18.29 2.51119 18.29 3.87998L18.29 19.88C18.29 21.2488 17.4021 22.78 15.85 22.78H8.14996C6.59785 22.78 5.70996 21.2488 5.70996 19.88L5.70996 3.87998Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgOrientationPortrait)
const IconSvgOrientationPortrait = createIcon(
  ForwardRef,
  'SvgOrientationPortrait',
)
export default IconSvgOrientationPortrait
